import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-generic-error-messages',
    templateUrl: './generic-error-messages.component.html',
    styleUrls: ['./generic-error-messages.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericErrorMessagesComponent {
  @Input() errorList;
  show:boolean = false;

  constructor() { }

  // CP-4380 --start
  toggleShow() {
    this.show = !this.show;
  }
  // CP-4380 --end
}
